import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDGONXWLshhqLxjU0RaLvJ9Bj246mkxxnE",
  authDomain: "twitter-clon-25a8e.firebaseapp.com",
  projectId: "twitter-clon-25a8e",
  storageBucket: "twitter-clon-25a8e.appspot.com",
  messagingSenderId: "132539386214",
  appId: "1:132539386214:web:56f10dd39347b8866d60a7",
  measurementId: "G-P8XFGZR8CJ"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

export default db;
